import Api from '../http.service';

/**Get All Point type
 * @param {Object} payload
 * @param {Number} payload.pageNumber
 * @param {Number} payload.itemPerPage
 * @param {Object} payload.data
 * @param {Object} payload.data.sort
 * @param {String} payload.data.sort.code
 * @param {Object} payload.data.filter
 * @param {String} payload.data.filter.code
 */
export const getAll = (payload) =>
  Api.POST({
    url: `point_type/all/${payload.pageNumber - 1}/${payload.itemPerPage}`,
    data: payload.data,
  });
